// Field-diagnostics client: tasks from the server, uploads of captures.

export interface DiagTask {
  id: string;
  title: string;
  detail: string;
}

const KEY = "trail.diagKey";

export function getDiagKey(): string {
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function setDiagKey(key: string): void {
  try {
    localStorage.setItem(KEY, key.trim());
  } catch {
    /* ignore */
  }
}

export async function fetchTasks(): Promise<DiagTask[]> {
  const key = getDiagKey();
  if (!key) return [];
  const r = await fetch("/diag/tasks", { headers: { authorization: `Bearer ${key}` } });
  if (!r.ok) throw new Error(`tasks: ${r.status}`);
  return (await r.json()) as DiagTask[];
}

export interface Capture {
  taskId: string | null;
  note: string;
  image: string | null; // data URL (JPEG)
  meta: Record<string, unknown>;
}

export async function uploadCapture(c: Capture): Promise<string> {
  const key = getDiagKey();
  if (!key) throw new Error("no diagnostics key");
  const r = await fetch("/diag/upload", {
    method: "POST",
    headers: { "content-type": "application/json", authorization: `Bearer ${key}` },
    body: JSON.stringify(c),
  });
  if (!r.ok) throw new Error(`upload: ${r.status}`);
  return ((await r.json()) as { stored: string }).stored;
}

export function deviceInfo(): Record<string, unknown> {
  const nav = navigator as Navigator & { deviceMemory?: number; standalone?: boolean };
  return {
    userAgent: nav.userAgent,
    platform: nav.platform,
    language: nav.language,
    hardwareConcurrency: nav.hardwareConcurrency,
    deviceMemory: nav.deviceMemory ?? null,
    standalone: nav.standalone ?? window.matchMedia?.("(display-mode: standalone)").matches ?? null,
    screen: { w: screen.width, h: screen.height, dpr: devicePixelRatio },
    online: nav.onLine,
  };
}
